import React from 'react'
import { AdminCustomerSummary } from '../../../types/api'
import { CssHandles } from '../../../hooks/useCssHandles'

type AdminCustomerStatsProps = {
  summary: AdminCustomerSummary
  handles: CssHandles
  formatCurrency: (value: number) => string
  isLoading: boolean
}

const AdminCustomerStats: React.FC<AdminCustomerStatsProps> = ({
  summary,
  handles,
  formatCurrency,
  isLoading
}) => {
  const activePercentage =
    summary.totalCustomers > 0
      ? `${Math.round(
          (summary.activeCustomers / summary.totalCustomers) * 100
        )}% da base`
      : '—'

  const averageTicket =
    summary.totalCustomers > 0
      ? formatCurrency(summary.totalRevenue / summary.totalCustomers)
      : '—'

  return (
    <div
      className={`${handles.customersStats} grid gap-4 md:grid-cols-3`}
      aria-live="polite"
    >
      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <p className="text-sm font-medium text-gray-500">Total de clientes</p>
        <p className="mt-2 text-3xl font-bold text-gray-900">
          {summary.totalCustomers}
        </p>
        <p className="mt-1 text-sm text-gray-500">
          {formatCurrency(summary.totalRevenue)} em receita gerada
        </p>
      </div>

      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <p className="text-sm font-medium text-gray-500">Clientes ativos</p>
        <p className="mt-2 text-3xl font-bold text-emerald-600">
          {summary.activeCustomers}
        </p>
        <p className="mt-1 text-sm text-gray-500">{activePercentage}</p>
      </div>

      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <p className="text-sm font-medium text-gray-500">Ticket médio</p>
        <p className="mt-2 text-3xl font-bold text-blue-600">{averageTicket}</p>
        <p className="mt-1 text-sm text-gray-500">Valores aproximados</p>
      </div>

      {isLoading && (
        <span className="sr-only">Atualizando dados de clientes...</span>
      )}
    </div>
  )
}

export default AdminCustomerStats

